import { render, staticRenderFns } from "./contactos.vue?vue&type=template&id=eb6137fe&"
import script from "./contactos.vue?vue&type=script&lang=js&"
export * from "./contactos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports